import { useEffect, useState } from 'react';
import { publicApi } from '../services/api';

export default function useCompanyInfo() {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicApi.getCompanyInfo()
      .then((res) => setInfo(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return { info, loading };
}
